import React, { useState, useContext } from "react";
import PropTypes from "prop-types";
import PaginateList from "../../../utils/PaginateList";
import * as WorkingPartServices from "../../../../services/WorkingPartService";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import moment from "moment-timezone";
import {
  ButtonAction,
  ButtonClose,
  Icon,
  Option,
  ListOptions,
  EditButton,
  DeleteButton,
} from "./workingPartUnitList.styled";
import { Can, AbilityContext } from "../../../security/permissions/Can";
import { USER_PERMISSIONS } from "../../../security/permissions/rolesPermission";
import {
  checkBootstrapSizeBreak,
  SIZES,
} from "../../../../utils/device/checkDevice";
import { ShowAlertDialog } from "@de-prado-dev/react-component-library";
import { converToTime } from "../../../../utils/formats/number";
import { useDailyPart } from "../hook/useDailyPart";

const WorkingPartUnitListContainer = ({ filters, sortBy }) => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const deviceSize = checkBootstrapSizeBreak();
  const [forceRefresh, setForceRefresh] = useState(false);
  const context = useContext(AbilityContext);
  const refresh = () => {
    setForceRefresh(true);
  };

  const listData = async (filter) => {
    if (sortBy) {
      filter.sort = sortBy;
    } else {
      filter.sort = "-initTime";
    }
    const result = await WorkingPartServices.listAllWorkingPartUnitsFilter(
      filter
    );
    return result;
  };

  const { updatePart, deletePart } = useDailyPart(refresh);

  const handlerPartUpdate = async (part) => {
    await updatePart(true, part.uuid);
  };

  const handlerPartDelete = async (part) => {
    await deletePart(true, part.uuid);
  };

  const getColumns = () => {
    const columns = [];
    columns.push({
      header: t("forms.workingPartUnit.table.heads.user"),
      accessorKey: "user.name",
      cell: (info) => `${info.getValue()} ${info.row.original.user.surname}`,
    });
    columns.push({
      header: t("forms.workingPartUnit.table.heads.initTime"),
      accessorKey: "initTime",
      cell: (info) =>
        info.getValue()
          ? moment(info.getValue()).format("DD-MM-YYYY HH:mm")
          : "-",
    });
    columns.push({
      header: t("forms.workingPartUnit.table.heads.endTime"),
      accessorKey: "endTime",
      cell: (info) =>
        info.getValue()
          ? moment(info.getValue()).format("DD-MM-YYYY HH:mm")
          : "-",
    });
    columns.push({
      header: t("forms.workingPartUnit.table.heads.taskTime"),
      accessorKey: "taskTime",
      cell: (info) => (info.getValue() ? converToTime(info.getValue()) : "-"),
    });
    columns.push({
      header: t("forms.workingPartUnit.table.heads.task"),
      accessorKey: "task.name",
      cell: (info) => {
        if (i18n.language === "pt") {
          return info.row.original.task.namePt;
        }
        return info.getValue();
      },
    });
    columns.push({
      header: t("forms.workingPartUnit.table.heads.numPlants"),
      accessorKey: "numPlants",
      cell: (info) => info.getValue(),
    });
    columns.push({
      header: t("forms.workingPartUnit.table.heads.location"),
      accessorKey: "code.location.name",
      cell: (info) => info.getValue(),
    });
    columns.push({
      header: t("forms.workingPartUnit.table.heads.variety"),
      accessorKey: "code.variety.name",
      cell: (info) => info.getValue(),
    });
    columns.push({
      header: t("forms.workingPartUnit.table.heads.code"),
      accessorKey: "code.batch.code",
      cell: (info) => info.getValue(),
    });
    columns.push({
      header: " ",
      accessorKey: " ",
      cell: (info) => renderAction(info.row.original),
    });

    return columns;
  };

  const hideColumn = {};
  let resize = null;

  if (deviceSize < SIZES.md) {
    // hideColumn.itemCode = false;
    resize = false;
  } else if (deviceSize === SIZES.md) {
    // hideColumn.itemCode = false;
  }

  const renderAction = (data) => {
    return (
      <div className="text-center">
        <ButtonAction onClick={() => handlerPartUpdate(data)} type="button">
          <i className="fa-solid fa-pen-to-square"></i>
        </ButtonAction>
        <ButtonAction
          onClick={() => handlerPartDelete(data)}
          type="button"
          $isDelete
        >
          <i className="fa-solid fa-trash-can"></i>
        </ButtonAction>
      </div>
    );
  };

  return (
    <>
      <PaginateList
        refresh={forceRefresh}
        filters={filters}
        columns={getColumns()}
        toList={listData}
        hideColum={hideColumn}
        resize={resize}
        resetRefresh={() => setForceRefresh(false)}
      ></PaginateList>
    </>
  );
};

WorkingPartUnitListContainer.propTypes = {
  filters: PropTypes.object,
};

export default WorkingPartUnitListContainer;
